// Port of api/fuel/app/classes/filter/advanced/evaluate.php
// AST evaluation for advanced filter rules. Supports AND/OR/NAND/NOR with set operations.

import Collection from './collection'

function uni(a, b) {
	if (!a || !a.length) return b || []
	if (!b || !b.length) return a
	var m = {}
	var out = []
	for (var i = 0; i < a.length; i++) { m[String(a[i])] = a[i]; out.push(a[i]) }
	for (var j = 0; j < b.length; j++) { if (!Object.prototype.hasOwnProperty.call(m, String(b[j]))) out.push(b[j]) }
	return out
}

function diff(a, b) {
	if (!a || !a.length) return []
	if (!b || !b.length) return a
	var m = {}
	for (var i = 0; i < b.length; i++) m[String(b[i])] = true
	var out = []
	for (var j = 0; j < a.length; j++) { if (!m[String(a[j])]) out.push(a[j]) }
	return out
}

function intersect(a, b) {
	if (!a || !a.length || !b || !b.length) return []
	var m = {}
	for (var i = 0; i < a.length; i++) m[String(a[i])] = true
	var out = []
	for (var j = 0; j < b.length; j++) { if (m[String(b[j])]) out.push(b[j]) }
	return out
}

function classifyNodeQuick(node) {
	// Leaf rule
	if (node.rule) {
		var rule = node.rule
		var type = String(rule.type || '').toLowerCase()
		var logic = rule.logic || {}
		var op = String(logic.operand || '=').toLowerCase()
		var val = logic.value

		if (type === 'collection.own' || type === 'model.collection_own' || type === 'own') {
			return enforcesOwn1NumericQuick(op, val) ? 'owned_only' : 'leaky'
		}
		if (type === 'collection.status' || type === 'collection_status') {
			var vals = toStringArrayQuick(val)
			if (hasAnyNonOwnedStatusQuick(vals)) return 'leaky'
			if (['=', '==', 'eq', 'in'].indexOf(op) !== -1 && vals.length === 1 && vals[0] === 'own') {
				return 'owned_only'
			}
			return 'neutral'
		}
		return 'neutral'
	}

	// Group
	if (node.rules && Array.isArray(node.rules)) {
		var anyLeaky = false
		var anyOwned = false
		for (var i = 0; i < node.rules.length; i++) {
			var c = classifyNodeQuick(node.rules[i])
			if (c === 'leaky') { anyLeaky = true; break }
			if (c === 'owned_only') anyOwned = true
		}
		if (anyLeaky) return 'leaky'
		return anyOwned ? 'owned_only' : 'neutral'
	}

	return 'neutral'
}

function enforcesOwn1NumericQuick(op, val) {
	if (['=', '==', 'eq'].indexOf(op) !== -1) {
		return parseInt(scalarQuick(val), 10) === 1
	}
	if (op === 'in' && Array.isArray(val)) {
		return val.length === 1 && parseInt(val[0], 10) === 1
	}
	return false
}

function scalarQuick(v) {
	if (Array.isArray(v)) return v[0]
	return v
}

function toStringArrayQuick(v) {
	if (v === null || v === undefined) return []
	if (Array.isArray(v)) return v.map(function(x) { return String(x) })
	return [String(v)]
}

function hasAnyNonOwnedStatusQuick(vals) {
	var nonOwned = ['prevowned', 'previouslyowned', 'want', 'wanted', 'wishlist', 'trade', 'fortrade', 'preordered', 'preorder', 'none', 'notowned']
	vals = vals.map(function(v) { return v.toLowerCase() })
	for (var i = 0; i < vals.length; i++) {
		if (nonOwned.indexOf(vals[i]) !== -1) return true
	}
	return false
}

function analyzeSequence(items) {
	var n = items.length
	var classes = []
	var joins = []
	var out = []

	for (var i = 0; i < n; i++) {
		var node = items[i]
		joins.push(String(node.logic || 'and').toLowerCase())
		classes.push(classifyNodeQuick(node))
		out.push({ needsOwn: false })
	}

	// Is there any LEAKY child that joins via OR?
	var hasLeakyOrSibling = false
	for (var j = 0; j < n; j++) {
		if (joins[j] === 'or' && classes[j] === 'leaky') {
			hasLeakyOrSibling = true
			break
		}
	}

	if (hasLeakyOrSibling) {
		if (n > 0 && classes[0] === 'neutral') {
			out[0].needsOwn = true
		}
		for (var k = 1; k < n; k++) {
			if (joins[k] === 'or' && classes[k] === 'neutral') {
				out[k].needsOwn = true
			}
		}
	}

	return out
}

function ownRule() {
	return {
		type: 'collection_status',
		setting: { logic: 'match' },
		logic: { operand: '=', value: ['own'] }
	}
}

function expandRuleWithLinks(item, needsOwn, ownScopes) {
	var batch = []
	if (item.rule) {
		batch.push(item.rule)
		if (item.links && Array.isArray(item.links)) {
			for (var i = 0; i < item.links.length; i++) {
				var lk = item.links[i]
				if (lk && lk.type && lk.logic) batch.push(lk)
				else if (lk && lk.rule) batch.push(lk.rule)
			}
		}
		var id = String(item.id || '')
		if (id !== '' && ownScopes[id]) batch.push(ownRule())
		else if (needsOwn) batch.push(ownRule())
	}
	return batch
}

function evalItem(item, seed, run, getU, ownScopes, needsOwnSeq) {
	// RULE ITEM
	if (item.rule) {
		var rules = [item.rule]
		if (item.links && Array.isArray(item.links)) {
			for (var i = 0; i < item.links.length; i++) {
				var lk = item.links[i]
				if (lk && lk.type && lk.logic) rules.push(lk)
				else if (lk && lk.rule) rules.push(lk.rule)
			}
		}
		var id = String(item.id || '')
		if (id !== '' && ownScopes[id]) rules.push(ownRule())
		else if (needsOwnSeq) rules.push(ownRule())
		return run(rules, seed)
	}

	// GROUP ITEM
	if (item.rules && Array.isArray(item.rules)) {
		var value = evalGroup(item, seed, run, getU, ownScopes)
		var gid = String(item.id || '')
		if ((gid !== '' && ownScopes[gid]) || needsOwnSeq) {
			var owned = run([ownRule()], seed)
			value = intersect(value, owned)
		}
		return value
	}

	return []
}

function evalGroup(group, seed, run, getU, ownScopes) {
	var items = (group.rules && Array.isArray(group.rules)) ? group.rules : []
	if (!items.length) return seed !== null && seed !== undefined ? seed : getU()

	var meta = analyzeSequence(items)

	var acc = null
	var have = false
	var andPack = []

	function flushAndPack() {
		if (!andPack.length) return
		var batchSeed = have ? acc : seed

		var rules = []
		for (var a = 0; a < andPack.length; a++) {
			for (var b = 0; b < andPack[a].length; b++) {
				rules.push(andPack[a][b])
			}
		}

		var value = run(rules, batchSeed)
		if (!have) { acc = value; have = true }
		else { acc = intersect(acc, value) }

		andPack = []
	}

	for (var i = 0; i < items.length; i++) {
		var item = items[i]
		var join = String(item.logic || 'and').toLowerCase()
		var isRule = !!item.rule
		var needsOwnSeq = meta[i] && meta[i].needsOwn

		if (join === 'and' && isRule) {
			andPack.push(expandRuleWithLinks(item, needsOwnSeq, ownScopes))
			continue
		}

		if (andPack.length) flushAndPack()

		if (!have) {
			if (join === 'nand' || join === 'nor') {
				var value = evalItem(item, seed, run, getU, ownScopes, needsOwnSeq)
				var universe = (seed !== null && seed !== undefined) ? seed : getU()
				acc = diff(universe, value)
			} else {
				acc = evalItem(item, seed, run, getU, ownScopes, needsOwnSeq)
			}
			have = true
			continue
		}

		if (join === 'and') {
			var v1 = evalItem(item, acc, run, getU, ownScopes, needsOwnSeq)
			acc = intersect(acc, v1)
		} else if (join === 'or') {
			var v2 = evalItem(item, seed, run, getU, ownScopes, needsOwnSeq)
			acc = uni(acc, v2)
		} else if (join === 'nand' || join === 'nor') {
			var v3 = evalItem(item, seed, run, getU, ownScopes, needsOwnSeq)
			acc = diff(acc, v3)
		} else {
			var v4 = evalItem(item, acc, run, getU, ownScopes, needsOwnSeq)
			acc = intersect(acc, v4)
		}
	}

	if (andPack.length) flushAndPack()

	return acc || []
}

export default {
	run: function(ast, runFlatAndSeeded, getUniverse) {
		if (!ast || !ast.logic) return []
		if (ast.rule && !ast.rules) {
			ast = { logic: 'and', rules: [ast] }
		}

		var ownScopes = Collection.idsRequiringOwn(ast)

		var universeCache = null
		var getU = function() {
			if (universeCache === null) {
				universeCache = getUniverse()
			}
			return universeCache
		}

		var ids = evalGroup(ast, null, runFlatAndSeeded, getU, ownScopes)

		// Unique
		var seen = {}
		var unique = []
		for (var i = 0; i < ids.length; i++) {
			if (!seen[String(ids[i])]) {
				seen[String(ids[i])] = true
				unique.push(ids[i])
			}
		}

		return unique
	}
}
